// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3vv5Q","box":"WorkspacesBox_box__YfYBv","node":"WorkspacesBox_node__2G8hR"};